import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { useCustomPageTitle } from '../../hooks/usePageTitle';
import UsageStatistics from '../../components/admin/UsageStatistics';
import AdminGuard from '../../components/admin/AdminGuard';

const AdminDashboard = () => {
  useCustomPageTitle('Administration');

  return (
    <AdminGuard>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex items-center justify-between mb-8">
          <h1 className="text-3xl font-bold">Administration</h1>
        </div>
        
        <div className="bg-white rounded-lg shadow">
          <Tabs defaultValue="statistics">
            <TabsList>
              <TabsTrigger value="statistics">Statistiques</TabsTrigger>
            </TabsList>

            <div className="p-6">
              <TabsContent value="statistics">
                <UsageStatistics />
              </TabsContent>
            </div>
          </Tabs>
        </div>
      </div>
    </AdminGuard>
  );
};

export default AdminDashboard;
